import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {AboutRoutingModule} from "./about-routing.module";
import {AboutComponent} from "./about.component";
import {TranslateModule} from '@ngx-translate/core';
import {ParallaxDirective} from "./parallax.directive";
import {SmartFormComponent} from "./smartform.component";
import {FormsModule} from "@angular/forms";
import {CounterDirective} from "./counter.directive";
import {AboutFormComponent} from "./aboutForm.component";
import {TextCaruselComponent} from "./text.carusel.component";

@NgModule({
    imports: [
        CommonModule,
        AboutRoutingModule,
        TranslateModule,
        FormsModule
    ],
    declarations: [
        AboutComponent,
        CounterDirective,
        ParallaxDirective,
        SmartFormComponent,
        // ContactFormComponent,
        AboutFormComponent,
        TextCaruselComponent
    ]
})
export class AboutModule {
}
